import ConnectedHero from "./ConnectedHero";
import ConnectedSmarter from "./ConnectedSmarter";
import ConnectedExpertise from "./ConnectedExpertise";
import ConnectedJiviews from "./ConnectedJiviews";

const Connected = () => {
    return (
        <>
            <ConnectedHero />
            <ConnectedSmarter />
            <ConnectedExpertise />
            <ConnectedJiviews />
        </>
    );
};

export default Connected;